import React,{useState,useCallback} from 'react';
//import Inc from "./Include";
import Hello from "./Hello";
import Count from "./Count";
import Hint from "./Hint";
//import Talk from "./Talk";
import './Board.scss';

let play = null;
//let survey = null;
//let closeAction = null;
let nextMembers = null;

function Board ({ajax,uid,name,setName,close}){
    //const [talk,setTalk] = useState(false);
    const [isActive,setIsActive] = useState(true);
    const [isHello,setIsHello] = useState(true);
    const [isCount,setIsCount] = useState(false);
    const [isHint,setIsHint] = useState(false);
    const [event,setEvent] = useState(null);
    const [members,setMembers] = useState(null);
    const [result,setResult] = useState(null);

    const closeHint = ()=> {
        setIsHint(false);
    }
    const closeCount = ()=> {
        setIsCount(false);
        setMembers(nextMembers);
        nextMembers = null;
        if( play.status==="1" ){
            nextEvent();
        } else {
            setIsActive(false)
        }
    }
    const closeHello = (p,e,m)=>{
        play = p;
        setEvent(e);
        setMembers(m)
        setIsHello(false);
        setName(p.name);
    }
    //const closeTalk = (num)=>{
    //   console.log("close:"+num);

    //    setResult(null);
    //    setTalk(null);

    //    if( closeAction ){
    //        closeAction(num);
    //        closeAction = null;
    //    }
    //}
    const goEnd = ()=>{
        console.log(play);
        close(play.result_key);
        //play = null;
        //setResult(null);
        //setEvent(null);
        //setIsActive(true);
        //newPlay();
    }
    const sendChoice = (answer)=>{
        ajax("log/add",{play_id:play.id,event_id:event.id,answer:answer},(res)=>{
            console.log(res);
            if( res.ok ){
                play = res.play;
                //setEvent(res.event);
                nextMembers = res.members;
                setResult(res.result);
            }
        });
    }
    const next = ()=>{
        setIsCount(true);
    }
    const hint = ()=>{
        setIsHint(true);
    }
    
    const nextEvent = useCallback(()=>{
        console.log("event/new");
        ajax("event/new",{play_id:play.id,event_id:result.next_id},(res)=>{
            console.log(res);
            if( res.ok ){
                play = res.play;
                setResult(null);
                setEvent(res.event);
            }
        });
    },[ajax,result]);
    //const burial = ()=>{
    //    closeAction = ()=>{
    //        nextEvent();
    //    }
    //    setTalk("burial");
    //}
    const br = useCallback( (str)=>{
        return str.split("\n").map( (value,index)=>{
            const key ="p"+index;
            let classname = "";
            if( value.substr(0,1)==="「" ){
                classname = "prompt";
            }
            return (
                <p key={key} className={classname}>{value}</p>
            )
        });
    },[])

    let text = "";
    let choices = "";
    if( !isActive ){
        text = "一人になったきみに赤い悪夢が襲い掛かる。きみは声を上げる猶予もなく、目を見開いたまま永遠の眠りに落ちる。";
        choices = (
            <button
                onClick={goEnd}
            >結果を見る</button>
        );
    } else {
        if( result ){
            text = result.text;
            choices = (
                <button
                    onClick={next}
                >良い</button>
            );
        } else if( event ){
            text = event.question;
            let list = event.choices;
            let rev = false;
            if( Math.random()<0.5 ){
                list = event.choices.reverse();
                rev = true;
            }
            choices = list.map( (value,index)=>{
                const key = "choice"+index;
                let no = index+1
                if( rev ){
                    no = 2-index;
                }
                return (
                    <button
                        key={key}
                        onClick={()=>sendChoice(no)}
                    >{value}</button>
                )
            });
        }
    }

    return (
		<div id="board">
            <div className="question">
                {br(text)}
            </div>
            {play &&
            <div className="page">p.{play.turn}</div>
            }
            <div className="choices">
                {choices}
            </div>
            <Hello ajax={ajax} uid={uid} defaultName={name} close={closeHello} isOpen={isHello}/>
            {members &&
            <React.Fragment>
            <Count close={closeCount} isOpen={isCount} members={members} nextMembers={nextMembers}/>
            <Hint close={closeHint} isOpen={isHint} members={members}/>
            <button
                className="hint"
                onClick={hint}
            >{members.length}人</button>
            </React.Fragment>
            }
        </div>
	)
}

export default Board;